<template>
  <!--  招聘首页-->
  <!--  <banner></banner>-->
  <div class="app-wrapper">
    <div class="wrap">
      <headerBlack class="header"></headerBlack>
      <div class="content">
        <div class="zpsy">
          <!--顶部banner-->
          <div class="bannershouye">
            <div class="text">
              一起探索有意思的未来
            </div>
            <div class="stext">
              从有意思的工作开始，让自己的人生变得有意义、有价值
            </div>
            <div class="search">
              <span class="icon"></span>
              <input type="text" class="input" @keydown.enter="search" placeholder="搜索工作岗位" ref="input"
                     v-model="value"/>
              <div class="more">
                <div> 查看工作岗位＞</div>

              </div>
            </div>
          </div>

          <!--    中间招聘模块-->

          <div class="zp">

            <div class="title">
              <div class="line"></div>
              <div class="text1">为什么选择沃特</div>
              <div class="text2">Why water</div>
            </div>


            <div class="jieshao">

              <div class="item">
                <div class="top">
                  <img src="@/assets/img/组 2754@2x.png" alt="" width="50px" height="50px">
                  <p>智慧连接，创造价值</p>
                </div>
                <div class="bot">
                  沃特长期致力于水利基础及数字内容核心业务的发展，积极拥抱产业互联网，努力为水利行业造福祉。
                </div>
              </div>
              <div class="item">
                <div class="top">
                  <img src="@/assets/img/工作环境.png" alt="" width="50px" height="50px">
                  <p>自由平等的工作环境</p>
                </div>
                <div class="bot">
                  轻松的办公环境，开放式工位，独立讨论区，灵感碰撞不受空间束缚。平等的工作氛围，坦诚的沟通风格帮你更自在的工作。
                </div>
              </div>
              <div class="item">
                <div class="top">
                  <img src="@/assets/img/关注成长.png" alt="" width="50px" height="50px">
                  <p>关注每一位新人的成长</p>
                </div>
                <div class="bot">
                  自由包容的文化氛围让你自由发展，你的声音会被认真聆听，在这里，你遇到的不只是同事，更是并肩成长的伙伴。
                </div>
              </div>
              <div class="item">
                <div class="top">
                  <img src="@/assets/img/福利关怀.png" alt="" width="50px" height="50px">
                  <p>全方位的贴心福利关怀</p>
                </div>
                <div class="bot">
                  温暖的节日礼品，掂量每一个值得庆祝的日子，多样化的健康关怀，助你更好地工作生活。
                </div>
              </div>
            </div>

          </div>

          <!--    职位-->
          <div class="zw">
            <div class="title">
              <div class="line"></div>
              <div class="text1">更多职位等你来发掘</div>
              <div class="text2">More positions for you to explore</div>
            </div>

            <div class="content">
              <div class="item" v-for="(item,index) in jobList">
                <div class="name">{{ item.name }}</div>
                <div class="gd" @click="go('/shzp',item.id)">查看岗位 ＞</div>
                <img :src="baseURL+item.img" alt="" class="img" width="40px" height="40px">
              </div>
            </div>
            <div class="genduo" @click="jobPosition">查看更多职位列表</div>
          </div>
          <!---->
          <!--员工故事    -->
          <div class="story">
            <div class="title">
              <div class="line"></div>
              <div class="text1">员工故事</div>
              <div class="text2">Employee story</div>
            </div>
            <div class="contend">
              <div class="item">
                <img src="@/assets/img/员工故事图片1.png" alt="" width="585px">

                <p class="text1">体验最极致的成就感</p>
                <div class="text2">公司没有让我们把所有时间都用来完成目标，仍然给大家很多时间，去做与业务没有直接关联的技术研究，大家都能停下脚步思考更多问题。</div>

              </div>
              <div class="item">
                <img src="@/assets/img/员工故事图片2.png" alt="" width="585px">
                <p class="text1">新人如何度过迷茫期</p>
                <div class="text2">职场很忌讳做事不踏实，如果小的事情都做不好，有谁还会相信你能做成大事呢?有理想和抱负固然是重要的，但也要一步一个脚印的走才行，把每一件小事做好、做细，通过积累和沉淀，做大事的机会终究会是你的。</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <wh-footer class="footer"></wh-footer>
  </div>

</template>

<script>

import banner from "@/components/banner";
import whFooter from "@/components/whFooter";
import headerBlack from "@/components/headerBlack";
import {getJobList} from "@/api/syindex";

export default {
  name: "zpindx",
  components: {banner, headerBlack, whFooter},
  data() {
    return {
      value: "",
      baseURL: "https://ahwater.net/file",
      jobList: []
    }
  },
  watch: {},
  mounted() {

  },
  created() {
    this.getList()
  },
  methods: {
    //去另一个页面
    go(item, id) {
      this.$router.push(item)

      window.sessionStorage.setItem('jobIds', JSON.stringify([id]))
    },
    //跳转职位列表
    jobPosition() {
      this.$router.push('/shzp')
    },
    //  职位列表
    async getList() {
      try {
        const {data} = await getJobList({
          size: 6,
          type: 1
        })
        this.jobList = data.data

      } catch (e) {

      }


    },
    //  监听键盘事件
    search() {
      window.sessionStorage.setItem('value', this.value)
      this.$router.push('/shzp')
    }
  },
}
</script>

<style scoped>
body {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
}

.app-wrapper {
  background-color: #f7f7f7;
}

.header {
  position: absolute;
  top: 0;
  left: 0;

}

.wrap {
  width: 100%;
  min-height: 100vh;
  /*background: lightgreen;*/
}

.content {
  padding-bottom: 150px;
  width: 100%;
}

.footer {
  margin-top: -150px;
}

.bannershouye {
  width: 100%;
  height: 656px;
  background-image: url("/src/assets/img/首页banner.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  box-sizing: border-box;
  padding-top: 221px;
}

.text {
  width: 1235px;
  height: 166px;
  font-size: 128px;
  font-family: banner, banner1;
  font-weight: 400;
  text-align: left;
  /*color: #ffffff;*/
  color: rgba(255, 255, 255, 0.85);
  letter-spacing: 5.7px;
  margin: 0px auto;

}

.stext {
  color: rgba(255, 255, 255, 0.85);
  text-align: center;
  font-size: 24px;
  font-family: banner, banner1;
  font-weight: 400;
}

.search {
  width: 1200px;
  height: 70px;
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
  margin: 60px auto;
  box-sizing: border-box;
  /*padding-left: 1px;*/
  overflow: hidden;
  font-family: normal;
  position: relative;
}

.input {
  box-sizing: border-box;
  width: calc(1200px - 166px);
  height: 70px;
  border: none;
  outline-style: none;
  padding: 26px 0px;
  padding-left: 55px;
  /*background-color: pink;*/
  font-size: 18px;

  /*background-image: none;*/
  background-size: 21px 21px;
  background-repeat: no-repeat;
  background-position: 25px 25px;

}

.icon {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 25px;
  left: 21px;

  background-image: url("/src/assets/img/搜索.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  z-index: 999;
  user-select: none;
}


input::-webkit-input-placeholder {
  position: relative;
  /*left: 55px;*/
}

.more {
  float: right;
  width: 166px;
  height: 70px;
  font-weight: 500;
  color: #3772d3;
  font-size: 18px;
  box-sizing: border-box;
  line-height: 70px;
  text-align: right;
  padding-right: 38px;
  cursor: pointer;
  user-select: none;
}

.zp {
  width: 100%;
  height: 780px;
  background-color: #666666;
  background-image: url("/src/assets/img/图像 98@2x.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;

}

.zp .title {
  width: 232px;
  height: 191px;
  margin: 0px auto;
  box-sizing: border-box;
  padding: 51px 0px 47px 0px;
}

.zp .line {
  width: 55px;
  height: 6px;
  background: #3772d3;
  border-radius: 3px;
  margin: 0px auto;
  margin-bottom: 10px;
}

.zp .text1 {
  width: 232px;
  height: 47px;
  font-size: 36px;
  font-family: banner;
  font-weight: 400;
  text-align: left;
  color: #333333;
  margin-bottom: 7px;
}

.zp .text2 {
  width: 232px;
  height: 23px;
  text-align: center;
  font-size: 20px;
  font-family: normal;
  font-weight: 400;
  color: #999999;
  letter-spacing: 2.4px;
}

.jieshao {
  width: 1200px;
  height: 506px;
  display: flex;
  flex-wrap: wrap;
  margin: 0px auto;
  justify-content: space-between;
}

.jieshao .item {
  width: 585px;
  height: 238px;
  border-radius: 4px;
  box-shadow: 0px 3px 15px 0px rgba(0, 0, 0, 0.10);
  margin-bottom: 30px;
  box-sizing: border-box;
  padding: 42px 43px 0px 45px;
}

.item .top {
  height: 50px;
  display: flex;
  align-items: center;
  margin-bottom: 27px;
}

.item .top p {

  font-size: 26px;
  font-family: normal;
  font-weight: 500;
  text-align: left;
  color: #303030;
  margin-left: 20px;
}

.item .bot {
  font-size: 16px;
  font-family: normal;
  font-weight: 400;
  text-align: left;
  color: #415165;
}

.zw {
  width: 100%;
  /*height: 820px;*/
}

.zw .title {
  width: 400px;
  height: 193px;
  /*background-color: pink;*/
  margin: 0px auto;
  box-sizing: border-box;
  padding: 60px 0px 40px 0px;
}

.zw .line {
  width: 55px;
  height: 6px;
  background: #3772d3;
  border-radius: 3px;
  margin: 0px auto;
  margin-bottom: 10px;
}

.zw .text1 {
  width: 400px;
  height: 47px;
  font-size: 36px;
  font-family: banner;
  font-weight: 400;
  text-align: center;
  color: #333333;
  margin-bottom: 7px;
}

.zw .text2 {
  width: 400px;
  height: 23px;
  font-size: 20px;
  font-family: normal;
  font-weight: 700;
  text-align: center;
  color: #999999;
  letter-spacing: 2.4px;
}

.zw .content {
  width: 1200px;
  /*height: 438px;*/
  margin: 0px auto;
  padding: 0px;

  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: flex-start

}

.zw .content .item {

  width: 585px;
  height: 126px;
  background: #ffffff;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
  float: left;
  margin-bottom: 30px;
  box-sizing: border-box;
  padding: 25px 0px 28px 39px;
  position: relative;

}

.zw .genduo {
  width: 291px;
  height: 73px;
  background: #ffffff;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
  margin: 46px auto;
  margin-top: 10px;
  line-height: 73px;
  text-align: center;
  font-size: 18px;
  font-family: normal;
  font-weight: 500;
  color: #3772d3;
  user-select: none;
  cursor: pointer;
}

.zw .item .name {
  margin-bottom: 31px;
  height: 24px;
  font-size: 24px;
  font-family: normal;
  font-weight: 500;
  text-align: left;
  color: #333333;
}

.zw .item .gd {
  /*width: 94px;*/
  height: 18px;
  font-size: 18px;
  font-family: normal;
  font-weight: 500;
  text-align: left;
  color: #3772d3;
  user-select: none;
  cursor: pointer;
}

.zw .item .img {
  position: absolute;
  top: 11px;
  right: 40px;
}

.story {

  width: 100%;
  height: 840px;
  /*background-color: #ac9da2;*/
  background-image: url("/src/assets/img/图像 98@2x.png");
  background-repeat: no-repeat;
  /*background: rgba(0, 0, 0, 0.00);*/
  background-size: 100% 100%;
}

.story .title {
  width: 202px;
  height: 191px;
  /*background-color: pink;*/
  margin: 0px auto;
  box-sizing: border-box;
  padding: 60px 0px 49px 0px;
}

.story .line {
  width: 55px;
  height: 6px;
  background: #3772d3;
  border-radius: 3px;
  margin: 0px auto;
  margin-bottom: 10px;
}

.story .text1 {
  width: 202px;
  height: 47px;
  font-size: 36px;
  font-family: banner;
  font-weight: 400;
  text-align: center;
  color: #333333;
}

.story .text2 {
  width: 202px;
  height: 23px;
  font-size: 20px;
  font-family: normal;
  font-weight: 700;
  text-align: center;
  color: #999999;
  letter-spacing: 2.4px;
}

.story .contend {
  width: 1200px;
  height: 500px;
  margin: 0px auto;
  /*background-color: #999999;*/
  display: flex;
  justify-content: space-between;
  padding: 25px 31px 34px 32px;
}

.story .item {
  width: 585px;
  height: 500px;
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0px 3px 15px 0px rgba(0, 0, 0, 0.10);
}

.story .item .text1 {
  width: 216px;
  height: 24px;
  font-size: 24px;
  font-family: normal;
  font-weight: 500;
  text-align: left;
  color: #303030;
  margin-left: 32px;
  margin-top: 25px;
  margin-bottom: 18px;
}

.story .item .text2 {
  width: 477px;
  height: 70px;
  font-size: 16px;
  font-family: normal;
  font-weight: 400;
  text-align: left;
  color: #999999;
  margin-left: 32px;
}


</style>